import { useQuery } from '@tanstack/react-query'

import { useCartStore } from '@/stores/cart-store/cartStore'

import { getPromotions } from '../api/getPromotion'

export const usePromotion = (promotionCode?: string) => {
	const location = useCartStore.use.location()

	return useQuery({
		queryKey: ['GET_PROMOTION', promotionCode, location?.hotelCode],
		queryFn: () => getPromotions(promotionCode!, location?.hotelCode),
		enabled: Boolean(promotionCode),
	})
}
